import apiInstance from '../../utils/axios/apiInstance';
import { encodeData } from '../../utils/url';

export const getAllNotificationsService = (page: number, per_page: number) => {
  const data : any = {
    page: page,
    per_page: per_page,
  };
  const params = encodeData(data);
  return apiInstance.get(`/notifications?${params}`);
}

export const updateNotificationsService = () => {
  return apiInstance.patch('/notifications');
}

export const deleteNotificationService = (id: number) => {
  return apiInstance.delete(`/notifications/${id}`);
}